
import React, { useState, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { supabase } from '../lib/supabase';

const PledgeCounter = () => {
  const [count, setCount] = useState(12547);
  const controls = useAnimation();

  useEffect(() => {
    // Load initial count
    loadPledgeCount();

    // Subscribe to changes
    const subscription = supabase
      .channel('pledge_count_changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'settings',
        filter: 'key=eq.pledge_count'
      }, handleCountChange)
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const loadPledgeCount = async () => {
    try {
      const { data, error } = await supabase
        .from('settings')
        .select('value')
        .eq('key', 'pledge_count')
        .single();

      if (error) throw error;
      if (data) {
        setCount(parseInt(data.value));
      }
    } catch (error) {
      console.error('Error loading pledge count:', error);
    }
  };

  const handleCountChange = (payload) => {
    if (payload.new && payload.new.value) {
      const newCount = parseInt(payload.new.value);
      setCount(newCount);
      controls.start({
        scale: [1, 1.1, 1],
        transition: { duration: 0.3 }
      });
    }
  };

  return (
    <motion.div
      animate={controls}
      className="mt-8 text-center"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="text-white/60"
      >
        Join
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="text-4xl font-bold text-white"
      >
        {count.toLocaleString()}
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="text-white/60"
      >
        Powder Protectors
      </motion.div>
    </motion.div>
  );
};

export default PledgeCounter;
